import financeComparisonPoster from "../assets/images/videoPosters/financeComparison.png";
import financeComparisonMobilePoster from "../assets/images/videoPosters/financeComparisonMobile.jpg";
import financeComparisonVideoWebm from "../assets/videos/FinanceComparison.webm";
import financeComparisonVideoMP4 from "../assets/videos/FinanceComparison.mp4";

import capitalFinanceIslamicVideoPoster from "../assets/images/videoPosters/capitalFinanceIslamic.jpg";
import capitalFinanceIslamicWebm from "../assets/videos/capitalFinanceIslamic.webm";
import capitalFinanceIslamicMp4 from "../assets/videos/capitalFinanceIslamic.mp4";

import capitalFinanceVideoPoster from "../assets/images/videoPosters/capitalFinance.jpg";
import capitalFinanceWebm from "../assets/videos/capitalFinance.webm";
import capitalFinanceMp4 from "../assets/videos/capitalFinance.mp4";

import assetBasedFinanceVideoPoster from "../assets/images/videoPosters/assetBasedFinance.jpg";
import assetBasedFinanceMp4 from "../assets/videos/assetBasedFinance.mp4";
import assetBasedFinanceWebm from "../assets/videos/assetBasedFinance.webm";

import businessFinancePoster from "../assets/images/videoPosters/businessFinance.jpg";
import businessFinanceMp4 from "../assets/videos/businessFinance.mp4";
import businessFinanceWebm from "../assets/videos/businessFinance.webm";

import businessFinanceIslamicVideoPoster from "../assets/images/videoPosters/businessFinanceIslamic.jpg";
import businessFinanceIslamicMp4 from "../assets/videos/businessFinanceIslamic.mp4";
import businessFinanceIslamicWebm from "../assets/videos/businessFinanceIslamic.webm";

import { financeNames } from "./index";

export const videos = [
  {
    financeType: financeNames.businessFinance,
    isIslamic: false,
    mp4: businessFinanceMp4,
    webm: businessFinanceWebm,
    poster: businessFinancePoster
  },
  {
    financeType: financeNames.businessFinance,
    isIslamic: true,
    mp4: businessFinanceIslamicMp4,
    webm: businessFinanceIslamicWebm,
    poster: businessFinanceIslamicVideoPoster
  },
  {
    financeType: financeNames.capitalFinance,
    isIslamic: false,
    mp4: capitalFinanceMp4,
    webm: capitalFinanceWebm,
    poster: capitalFinanceVideoPoster
  },
  {
    financeType: financeNames.capitalFinance,
    isIslamic: true,
    mp4: capitalFinanceIslamicMp4,
    webm: capitalFinanceIslamicWebm,
    poster: capitalFinanceIslamicVideoPoster
  },
  {
    financeType: financeNames.assetBasedFinance,
    isIslamic: false,
    mp4: assetBasedFinanceMp4,
    webm: assetBasedFinanceWebm,
    poster: assetBasedFinanceVideoPoster
  },
  {
    financeType: financeNames.assetBasedFinance,
    isIslamic: true,
    mp4: assetBasedFinanceMp4,
    webm: assetBasedFinanceWebm,
    poster: assetBasedFinanceVideoPoster
  },
  {
    financeType: "",
    isIslamic: false,
    mp4: financeComparisonVideoMP4,
    webm: financeComparisonVideoWebm,
    poster: financeComparisonPoster,
    mobilePoster: financeComparisonMobilePoster
  }
];
